export { default as ProductRatingQuery } from './ProductRatingQuery';